import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getCodeVerifier(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getSyncZalo(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    authenticateDomain(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    callbackZalo(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    checkURLCallback(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getListUsersZalo(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getListMessages(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    storeSettingConnectZalo(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    syncListFollowers(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    sendInviteCooperate(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
})()